/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown> }} Confirm_Ad_Job_TextInputs */

const en_confirm_ad_job_text = /** @type {(inputs: Confirm_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This job will cost approximately $${i?.cost} USD. Do you want to proceed?`)
};

const fr_confirm_ad_job_text = /** @type {(inputs: Confirm_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ce travail coûtera environ $${i?.cost} USD. Voulez-vous continuer ?`)
};

const de_confirm_ad_job_text = /** @type {(inputs: Confirm_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieser Auftrag kostet ungefähr ${i?.cost} USD. Möchten Sie fortfahren?`)
};

const it_confirm_ad_job_text = /** @type {(inputs: Confirm_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questo lavoro costerà circa $${i?.cost} USD. Vuoi procedere?`)
};

const ru_confirm_ad_job_text = /** @type {(inputs: Confirm_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Эта работа обойдется примерно в $${i?.cost} долларов США. Вы хотите продолжить?`)
};

const es_confirm_ad_job_text = /** @type {(inputs: Confirm_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este trabajo tendrá un costo aproximado de $${i?.cost} USD. ¿Desea continuar?`)
};

const zh_cn2_confirm_ad_job_text = /** @type {(inputs: Confirm_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`这项工作大约需要花费 $${i?.cost} 美元。您是否要继续？`)
};

const ja_confirm_ad_job_text = /** @type {(inputs: Confirm_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この作業には約$${i?.cost}米ドルの費用がかかります。続行しますか？`)
};

const hi_confirm_ad_job_text = /** @type {(inputs: Confirm_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इस काम में लगभग $${i?.cost} USD का खर्च आएगा। क्या आप आगे बढ़ना चाहते हैं?`)
};

const pt_pt2_confirm_ad_job_text = /** @type {(inputs: Confirm_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este serviço custará aproximadamente $${i?.cost} USD. Deseja prosseguir?`)
};

/**
* | output |
* | --- |
* | "This job will cost approximately ${cost} USD. Do you want to proceed?" |
*
* @param {Confirm_Ad_Job_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const confirm_ad_job_text = /** @type {((inputs: Confirm_Ad_Job_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Ad_Job_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_confirm_ad_job_text(inputs)
	if (locale === "de") return de_confirm_ad_job_text(inputs)
	if (locale === "it") return it_confirm_ad_job_text(inputs)
	if (locale === "ru") return ru_confirm_ad_job_text(inputs)
	if (locale === "es") return es_confirm_ad_job_text(inputs)
	if (locale === "zh-CN") return zh_cn2_confirm_ad_job_text(inputs)
	if (locale === "ja") return ja_confirm_ad_job_text(inputs)
	if (locale === "hi") return hi_confirm_ad_job_text(inputs)
	if (locale === "pt-PT") return pt_pt2_confirm_ad_job_text(inputs)
	return en_confirm_ad_job_text(inputs)
});